import * as React from "react";
import Svg, { Path, G } from "react-native-svg";

function SvgComponent(props) {
  return (
    <Svg
      width={166}
      height={116}
      viewBox="0 0 166 116"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <Path
        d="M158.87 115.186c-10.425 0-151.36-.303-151.36-.32-.06-.137-17.892-21.994 4.563-44.846 11.127-11.323-10.217-25.992 0-38.587C29.576 9.858 46.893 22.008 61.32 15.94c2.55-1.071 5.107-2.794 7.668-5.44A28.501 28.501 0 0173.7 6.588a31.348 31.348 0 013.93-2.212c.726-.343 1.465-.66 2.22-.95a36.375 36.375 0 013.68-1.199 41.692 41.692 0 015.488-1.077 45.88 45.88 0 012.468-.252c16.121-1.212 34.261 5.605 43.624 15.568 1.884 2.006 10.455 12.386 3.699 26.655-4.266 9.008 13.605 17.611 19.955 27.899 16.145 26.154.252 43.825.105 44.166h.001z"
        fill="#E7E7E7"
      />
      <G opacity={0.8}>
        <Path
          opacity={0.8}
          d="M122.395 54.379a20.38 20.38 0 01-7.297 9.639c-5.312 3.81-12.353 5.02-18.961 2.618-7.862-2.858-12.911-10.024-13.448-17.864a20.472 20.472 0 011.19-8.394 20.587 20.587 0 011.926-3.94l.026-.042a20.452 20.452 0 018.624-7.579A20.551 20.551 0 0199.03 27.3a20.38 20.38 0 0111.107.82c.49.177.969.372 1.436.583a20.366 20.366 0 018.306 6.857 20.596 20.596 0 013.582 9.174 20.42 20.42 0 01.107 4.279 20.554 20.554 0 01-1.174 5.367v-.001z"
          fill="#D7E5FF"
        />
        <G opacity={0.8} fill="#AEC3FF">
          <Path
            opacity={0.8}
            d="M99.728 36.379c-1.21.937-.89 3.447-2.986 2.033-2.097-1.415-3.412-2.184-4.006-.95-.594 1.235 1.263 1.91.775 3.256-.49 1.345-1.484 1.487-2.532.382-1.05-1.104-1.08-2.167-2.778-2.132-1.699.035-2.423-.663-2.34-1.939a1.794 1.794 0 00-.056-.591l.026-.042a20.451 20.451 0 018.624-7.579A20.535 20.535 0 0199.03 27.3c.593.24 1.228.729 1.564 1.708.739 2.155 1.939 1.647.92 3.452-1.019 1.805-.599 2.248.512 2.58 1.113.33 2.394.796 2.219 1.676-.175.879-3.307-1.276-4.518-.337zM122.395 54.379a20.38 20.38 0 01-7.297 9.639 2.337 2.337 0 01-1.525-.602c-2.053-1.834.667-3.781 2.099-4.73 1.433-.947-1.226-1.261-2.567-3.108-1.341-1.846 1.798-4.35-.219-4.484-2.018-.135-4.471-.266-4.882-2.427-.411-2.161 1.711-1.717 1.34-3.537-.371-1.82 1.384-2.162 3.261-1.642 1.878.519 2.109-.865 4.436-.236 2.328.628 1.232 3.492 3.8 4.208 2.567.716 2.245 1.252 2.245 1.252.182.06.343.161.482.299a20.593 20.593 0 01-1.173 5.367zM123.462 44.734c-2.445.255-2.279-2.797-4.355-2.615-2.092.182-1.197-1.306-2.232-2.842-1.037-1.536-4.53-.703-3.82-2.259.71-1.554 2.66-.338 3.574-1.455.914-1.118 2.847-.053 2.847-.053a1.5 1.5 0 01.404.05h.001a20.618 20.618 0 013.581 9.174zM107.972 32.85s1.659-1.175.099-2.268c-1.561-1.092-1.75-.473-3.042-1.106-1.293-.632-2.2.217-1.604 1.72.595 1.504.619 3.982 1.954 3.151 1.335-.83 1.48-1.775 2.593-1.498z"
          />
        </G>
      </G>
      <Path
        d="M12.164 114.924h7.147c.383-.325-.265-1.063-.942-1.112-.294-.023-.666.039-1.09.129-.1-1.307-.66-7.179-2.777-6.943-2.38.265 0 2.586.672 3.961.499 1.018 1.024 2.478 1.264 3.167-.193.042-.393.083-.598.121-.315-.969-1.489-4.227-2.982-4.037-1.752.223-1.048 1.529.195 2.304.91.571 2.03 1.381 2.561 1.772a7.56 7.56 0 01-1.397.112c-1.224-.029-1.822.331-2.054.525l.001.001zM125.906 114.924h-6.638c-.356-.302.246-.987.875-1.033.273-.021.618.036 1.013.119.091-1.213.612-6.668 2.579-6.448 2.211.245 0 2.402-.625 3.679-.463.945-.951 2.301-1.175 2.942.18.038.365.076.555.111.294-.899 1.383-3.926 2.77-3.749 1.628.207.973 1.42-.18 2.14-.847.53-1.886 1.282-2.38 1.646.418.068.855.115 1.298.104 1.137-.027 1.692.308 1.907.488l.001.001z"
        fill="#A8D29F"
      />
      <Path
        d="M130.647 71.41s.158-1.572-.664-1.518c-.821.054-1.039.43-.947.733.091.302.891 1.302.891 1.302l.721-.517h-.001z"
        fill="#FFB27D"
      />
      <Path
        d="M143.452 74.558s-.91 1.07-2.866 2.303a21.746 21.746 0 01-3.263 1.673 10.47 10.47 0 01-.396.151c-1.173.424-3.33 1.024-4.666 1.078a4 4 0 01-.33 0c-2.034-.082-2.282-7.978-2.282-7.978s.226-.79 1.272-.59c0 0 1.587 4.46 2.156 4.823.505.323 3.409-4.08 5.909-4.388 1.683-.207 4.466 2.93 4.466 2.93v-.002z"
        fill="#739AF0"
      />
      <Path
        d="M137.986 113.067s.151 1.738-.217 1.919l-4.703-.01s0-.543.756-.663c.755-.121 2.082-.563 2.306-1.548.225-.985 1.858.302 1.858.302z"
        fill="#1C3154"
      />
      <Path
        d="M134.534 92.028c.023 1.137.078 2.31.185 3.363.507 5 .686 11.042.759 12.207.127 2.021.526 5.252.526 5.252s.793.752 2.337.393c0 0 1.279-4.652 1.565-9.551l.013-.242c.033-.648.067-1.388.103-2.186.235-5.349.491-13.294.491-13.294l-5.901-1.386s-.136 2.611-.078 5.445v-.001z"
        fill="#2A4E96"
      />
      <Path
        d="M134.534 92.028c1.495 2.58 4.346 7.334 5.488 9.234.235-5.348.491-13.294.491-13.294l-5.901-1.386s-.136 2.612-.078 5.446z"
        fill="#233862"
      />
      <Path
        d="M136.927 78.685c-1.173.423-3.33 1.023-4.666 1.077.204-.038 1.693-.333 2.243-.997.591-.715 1.586-2.655 2.378-1.863.373.373.263 1.11.045 1.783z"
        fill="#6385DB"
      />
      <Path
        d="M146.843 91.187s.366 1.437.306 1.756c-.06.32-.418 1.4-.641 1.669-.223.268-.232-1.166-.381-1.392-.148-.225-.068.536-.187.598-.119.062-.317-.576-.405-.802-.088-.227.316-1.015.354-1.58.038-.565.953-.249.953-.249h.001z"
        fill="#FFB27D"
      />
      <Path
        d="M149.701 111.092s.837.764.674 1.306c-.164.543-.919.905-1.021 1.568-.102.663-.51 1.025-.878 1.025h-1.752s-.27-.467.383-.608c.654-.141.9-.92.859-1.644-.041-.724.061-1.688.061-1.688l1.388-.322.286.362v.001z"
        fill="#1C3154"
      />
      <Path
        d="M135.542 88.09s5.524 11.819 8.464 17.005c2.939 5.186 3.858 6.633 3.858 6.633s1.684-.663 1.837-1.115c0 0-1.124-10.013-3.093-12.453-1.112-1.379-2.419-5.518-2.48-6.965-.061-1.447-1.352-4.902-1.352-4.902l-7.234 1.796z"
        fill="#2A4E96"
      />
      <Path
        d="M134.512 87.474s1.798 1.936 4.855 2.52c1.342.258 4.065.506 4.74-.45.158-.224.16-.556.124-1.074-.09-1.347-.429-3.952 1.101-9.187.142-.486.238-.954.294-1.399.334-2.678.297-4.699-2.026-5.779-3.481-1.618-4.91-.287-4.91-.287s-1.851.865-2.697 3.387c-1.692 5.043-1.482 12.269-1.482 12.269h.001z"
        fill="#739AF0"
      />
      <Path
        d="M141.511 71.66a2.583 2.583 0 01-2.6.17c-.076-.037-.066-.557-.047-1.068.019-.5.066-.993.066-.993l1.239-.813 1.182-.775c-.142 2.666.425 3.29.161 3.479h-.001z"
        fill="#FFB27D"
      />
      <Path
        d="M141.142 69.282s-.804 1.207-2.279 1.481c.019-.5.073-1.053.073-1.053l1.232-.753.975.326h-.001z"
        fill="#ED985F"
      />
      <Path
        d="M137.82 69.456s2.997 1.119 3.664-.728c.667-1.847 1.502-2.945-.383-3.737-1.885-.793-2.513-.221-2.888.34-.375.563-1.156 3.787-.393 4.125z"
        fill="#FFB27D"
      />
      <Path
        d="M143.351 65.198c.034-.027.104-.04.25-.019 0 0-.101-.095-.255-.13.01-.206-.027-.583-.355-.737 0 0 .166.136.149.354-.319-.49-1.118-.958-3.528-1.24-3.176-.37-2.541 1.836-2.183 2.155.358.318 1.506-.135 2.249.074.743.21.671 1.328.897 1.528.226.2.178-.085.555-.173.377-.088.297.492.123.846-.174.353.205.94.205.94l.583-.423c.583-.423 1.469-2.527 1.343-3.038l-.033-.136v-.001z"
        fill="#2C3A64"
      />
      <Path
        d="M144.232 88.47c-.091-1.347-.43-3.952 1.1-9.187.143-.486.239-.954.294-1.399-1.137-.375-3.207.459-3.207.459s-.487 6.919 1.814 10.126h-.001z"
        fill="#6385DB"
      />
      <Path
        d="M144.227 72.456s1.399.508 2.291 4.212c.59 2.447 1.675 6.043 1.798 7.174.122 1.13-1.241 7.747-1.241 7.747s-.192.14-.664.046c-.451-.09-.66-.396-.66-.396s-.326-4.41-.242-6.493c.035-.865-4.005-6.336-6.186-7.04-.856-.277 4.904-5.251 4.904-5.251z"
        fill="#739AF0"
      />
      <Path
        d="M124.663 67.662s4.042-.115 8.708.744l.487-1.229.535-1.345s-4.684-2.016-7.499-4.824l-2.231 6.654z"
        fill="#AEC3FF"
      />
      <Path
        d="M126.957 60.942l-2.321 6.852a.617.617 0 01-.407-.799l2.043-5.757a.51.51 0 01.685-.296zM129.173 72.76a.84.84 0 00.985-.655l.799-4a.84.84 0 00-.656-.984.84.84 0 00-.985.656l-.799 4a.84.84 0 00.656.984z"
        fill="#F99746"
      />
      <Path
        d="M124.663 67.662s4.042-.115 8.708.744l.487-1.229c-4.384-.895-9.195.484-9.195.484z"
        fill="#739AF0"
      />
      <Path
        d="M132.081 68.158l1.263.222c-.019.001 1.173.233 1.564-.825a.849.849 0 00.076-.228c.304-1.317-.42-1.56-.42-1.56l-1.625-.634-.517 1.829v.006l-.34 1.19h-.001z"
        fill="#F99746"
      />
      <Path
        d="M132.081 68.158l1.263.222c-.019.001 1.173.233 1.564-.825-.714-.52-2.486-.594-2.486-.594v.006l-.341 1.19v.001z"
        fill="#ED7D2B"
      />
      <Path
        d="M129.281 68.889s.618.246.504.519c-.113.272-.899.646-1.023.431-.123-.214.13-1.18.519-.95zM130.659 71.162s.117-.633.124-.923c.007-.29.041-.528-.027-.536-.068-.008-.118.045-.146.138-.028.094-.135.673-.135.673l.055.56.13.087h-.001z"
        fill="#FFB27D"
      />
      <Path
        d="M69.534 70.749l-3.501 41.631s-.367 2.523 1.51 2.528c3.086.007 15.362 0 15.362 0s-2.323-.526-2.294-1.707c.033-1.393 4.092-42.846 4.092-42.846l-15.17.394z"
        fill="#7599EA"
      />
      <Path
        d="M84.06 114.169c-.607.002-12.49.022-15.497-.017-1.31-.016-1.54-1.165-1.55-1.907-.006-.356.04-.62.04-.62l.09-1.082.233-2.758.204-2.436.264-3.131.222-2.643 2.488-29.582 15.169-.394s-1.71 17.348-2.919 29.975c-.135 1.407-.263 2.756-.382 4.015l-.112 1.178a2686.838 2686.838 0 00-.433 4.68c-.154 1.703-.245 2.791-.246 2.997 0 .121.01.233.03.337.248 1.327 2.171 1.387 2.4 1.387v.001z"
        fill="#90AFF4"
      />
      <Path
        d="M32.697 48.096l8.528 34.257 1.167 4.69L46.365 103h73.796L105.52 48.096H32.697z"
        fill="#AEC3FF"
      />
      <Path
        d="M32.697 48.095l-1.183.395 13.28 55.701 1.57-1.191-13.667-54.905z"
        fill="#90AFF4"
      />
      <Path
        d="M44.793 104.191h73.342L120.16 103H46.365l-1.572 1.191z"
        fill="#7599EA"
      />
      <Path d="M70.548 114.924h15.88v-.755h-15.88v.755z" fill="#AEC3FF" />
      <Path
        d="M82.392 104.191l-.082.577-14.934 3.017.204-2.436.098-1.158h14.714z"
        fill="#5888DD"
      />
      <Path
        opacity={0.4}
        d="M84.06 114.169c-.607.002-12.491.022-15.497-.017-1.31-.016-1.54-1.165-1.55-1.907l14.863-2.797c-.154 1.703-.245 2.791-.246 2.998 0 .12.01.233.03.337.248 1.327 2.172 1.386 2.4 1.386z"
        fill="#5888DD"
      />
      <Path
        d="M32.697 48.095h72.823l11.816 44.126H43.682L32.697 48.095z"
        fill="#AEC3FF"
      />
      <Path
        d="M113.901 90.31H45.716l-2.437-9.708-.942-3.755-.385-1.532-2.504-9.975-.13-.519-1.324-5.273-.592-2.359-.505-2.013-1.185-4.717h67.203l1.301 4.717.554 2.013.651 2.36 4.285 15.542.363 1.317.168.612 2.958 10.73.706 2.56z"
        fill="#739AF0"
      />
      <Path
        d="M104.216 55.176h-67.32l-1.183-4.718h67.202l1.301 4.718z"
        fill="#607CF4"
      />
      <Path
        d="M38.493 52.591c-.08-.325.117-.59.443-.59.325 0 .655.265.736.59.081.326-.117.59-.442.59-.326 0-.656-.264-.737-.59zM40.453 52.591c-.081-.325.117-.59.442-.59.326 0 .656.265.737.59.08.326-.117.59-.443.59-.325 0-.655-.264-.736-.59zM42.563 52.591c-.081-.325.116-.59.442-.59s.656.265.736.59c.081.326-.116.59-.442.59s-.656-.264-.736-.59z"
        fill="#E9F3FE"
      />
      <Path
        d="M116.88 91.249L57.632 96.24c-4.498.38-7.754-4.207-5.913-8.329L76.82 31.735c1.905-4.261 7.758-4.755 10.348-.871l34.147 51.184c2.506 3.756.063 8.822-4.435 9.201z"
        fill="#E6EFFF"
      />
      <Path
        d="M117.069 93.489l-59.248 4.992a8.106 8.106 0 01-7.356-3.416 8.106 8.106 0 01-.798-8.072l25.1-56.176c1.234-2.76 3.77-4.56 6.782-4.814 3.013-.253 5.813 1.096 7.491 3.612l34.147 51.184a8.105 8.105 0 01.564 8.091 8.108 8.108 0 01-6.682 4.599zM81.927 30.485a3.634 3.634 0 00-3.053 2.167l-25.1 56.176a3.649 3.649 0 00.36 3.633 3.649 3.649 0 003.31 1.537l59.248-4.991a3.649 3.649 0 003.007-2.07 3.648 3.648 0 00-.254-3.642L85.299 32.111a3.636 3.636 0 00-3.372-1.626z"
        fill="#F77D48"
      />
      <Path
        d="M80.538 82.654a5.417 5.417 0 01.23-2.152 4.968 4.968 0 011.014-1.78 5.326 5.326 0 011.703-1.263c.677-.324 1.454-.525 2.331-.598.877-.074 1.683-.007 2.416.198.734.206 1.37.526 1.907.958.538.433.97.962 1.297 1.586.327.625.523 1.319.587 2.083a5.308 5.308 0 01-.232 2.134 5.004 5.004 0 01-1.015 1.764 5.283 5.283 0 01-1.72 1.263c-.688.326-1.471.526-2.349.6-.877.074-1.677.007-2.398-.2a5.313 5.313 0 01-1.89-.96 4.993 4.993 0 01-1.295-1.568 5.301 5.301 0 01-.586-2.065zm9.16-10.719l-8.535.719-3.665-29.058 10.952-.923 1.248 29.262z"
        fill="#F77D48"
      />
      <Path
        d="M43.747 73.718s.186-.418.306-.616.635-.777.722-.646c.087.131.438 1.014.252 1.262-.186.247.012.677-.913.938l-.366-.938z"
        fill="#FFB27D"
      />
      <Path
        d="M33.472 71.079s4.733 3.951 6.579 3.585c1.443-.286 3.724-1.009 3.724-1.009s.602.573.432 1.26c0 0-2.906 2.734-4.977 2.752-3.238.027-4.764-1.604-4.764-1.604l-.994-4.983v-.001z"
        fill="#ED7D2B"
      />
      <Path
        d="M25.17 112.755s.137 2.217.567 2.249c.057.004 2.175.004 2.175.004l2.704-.016s-.018-.651-.808-.789-2.114-.693-2.593-1.737c-.503-1.099-2.045.289-2.045.289z"
        fill="#113C68"
      />
      <Path
        d="M25.015 112.909s.821.275 1.464.275c.716 0 1.366-.195 1.366-.195s.155-1.496 1.006-4.793a109.09 109.09 0 011.99-6.712c2.508-7.631 3.27-12.096 3.34-12.518a1.65 1.65 0 00.005-.033l-.008-.004-7.71-3.385s.953 10.518-.264 14.555c-.17.564-.316 1.222-.44 1.934-.769 4.384-.75 10.876-.75 10.876z"
        fill="#2A4E96"
      />
      <Path
        d="M28.85 108.196a109.15 109.15 0 011.991-6.712c2.508-7.631 3.27-12.096 3.34-12.518a.661.661 0 00-.002-.037l-7.71-3.386s.952 10.518-.264 14.555c-.17.564 2.645 8.098 2.645 8.098z"
        fill="#233862"
      />
      <Path
        d="M31.193 112.755s.137 2.217.566 2.249c.057.004 2.175.004 2.175.004l2.704-.016s-.017-.651-.808-.789c-.79-.138-2.113-.693-2.592-1.737-.504-1.099-2.045.289-2.045.289z"
        fill="#15447C"
      />
      <Path
        d="M35.564 85.792s.1 6.815-1.08 15.183c-1.178 8.369-.779 11.92-.779 11.92s-.81.263-1.136.289c-.833.068-1.687-.195-1.687-.195s-1.688-8.371-1.204-12.56c.484-4.188-2.31-14.372-2.31-14.372l8.197-.266h-.001z"
        fill="#2A4E96"
      />
      <Path
        d="M30.097 69.843l1.504.987 1.371-.388c.25-.357.318-1.046.321-1.643a10.22 10.22 0 00-.054-1.095l-2.03-.896-.758-.334c.002.012.059.622.066.711.142 1.582-.421 2.658-.421 2.658z"
        fill="#FFB27D"
      />
      <Path
        d="M35.598 87.686c-1.873 1.809-8.962 1.505-9.4-.488-.436-1.993.477-16.964 3.677-17.904.664-.195 4.214.952 4.214.952s.558 1.458.923 3.313c.07.36.277 4.187.432 7.766.073 1.674.134 3.294.165 4.48.028 1.112.03 1.842-.01 1.882z"
        fill="#F99746"
      />
      <Path
        d="M30.67 67.213c.413.696 1.858 1.306 2.624 1.585.003-.592-.054-1.094-.054-1.094l-2.031-.896c-.45-.006-.723.094-.54.405h.002z"
        fill="#FCA56B"
      />
      <Path
        d="M34.006 67.58s-3.272 1.02-3.876-1.026c-.605-2.047-1.434-3.295.63-4.033 2.062-.738 2.701-.077 3.07.557.367.635 1.011 4.185.176 4.503v-.001z"
        fill="#FFB27D"
      />
      <Path
        d="M33.7 62.88s-.209 2.383-.7 2.28c-.493-.103-1.036-.325-.964.393.072.719-.479 1.95-1.19 1.947-1.523-.007-3.178-3.916-2.761-4.658 1.203-2.14 7.355-2.571 5.615.039z"
        fill="#163560"
      />
      <Path
        d="M33.22 69.345c-.043-.018-2.436-1.091-2.716-.999-.28.092-.629.947-.629.947l4.214.953s-.332-.675-.87-.901z"
        fill="#ED7D2B"
      />
      <Path
        d="M48.12 80.94L34.704 93.57c-.264.248-.595.327-.738.175l-.453-.48c-.142-.152-.043-.478.22-.726l13.416-12.632c.263-.248.595-.326.737-.175l.453.481c.142.151.044.478-.22.725z"
        fill="#1F4D84"
      />
      <Path
        d="M40.59 88.028l-5.886 5.543c-.264.248-.595.327-.738.175l-.453-.48c-.142-.152-.043-.478.22-.726l5.887-5.543.97 1.03v.001z"
        fill="#739AF0"
      />
      <Path
        d="M45.036 76.17a10.453 10.453 0 002.854 4.59c4.23 3.98 10.885 3.777 14.865-.452 3.926-4.175 3.78-10.71-.29-14.706a7.32 7.32 0 00-.165-.159c-4.229-3.979-10.884-3.777-14.863.453a10.513 10.513 0 00-2.402 10.275zm3.006-9.705a9.675 9.675 0 018.714-2.906 9.64 9.64 0 014.977 2.489c3.895 3.665 4.082 9.794.417 13.69a9.645 9.645 0 01-4.815 2.788 9.686 9.686 0 01-9.293-16.06v-.001z"
        fill="#1F4D84"
      />
      <Path
        opacity={0.5}
        d="M62.15 79.739a9.677 9.677 0 01-13.69.418c-3.897-3.666-4.084-9.796-.418-13.692a9.675 9.675 0 018.714-2.906 9.637 9.637 0 014.977 2.489c3.895 3.665 4.082 9.795.417 13.69z"
        fill="#B3CFF9"
      />
      <Path
        d="M35.609 85.805c-7.393-5.267-6.778-12.297-6.778-12.297 2.702 1.524 5.383 4.893 6.613 7.816.073 1.674.134 3.294.165 4.481z"
        fill="#ED7D2B"
      />
      <Path
        d="M42.905 83.406c.521-.12.872-.514.944-.583 0 0 .223.016-.036.49-.022.04-.07.141-.107.214a.046.046 0 00.04.066c.3.023.603-.097 1.182.024.08.017.103.209.1.29-.005.138.004.294-.156.505-.093.123-.354.256-.934.49-.221.088-.854.021-1.446-.182l-.473-.22.147-.88.119.025c.188.04.423-.19.62-.239z"
        fill="#FFB27D"
      />
      <Path
        d="M31.126 70.246s-6.642 1.265 1.954 10.884c1.375 1.538 8.803 3.541 8.803 3.541s.753-.64.374-1.16c0 0-5.115-3.714-6.24-4.304-.507-.266-1.965-5.928-2.79-7.292-.825-1.363-2.101-1.669-2.101-1.669z"
        fill="#F99746"
      />
      <Path
        d="M43.927 73.834s.218-.415.26-.635c.042-.219.316-.857.428-.97.045-.045.194.013.212.207.008.084-.034.238-.107.42-.119.297-.099.7-.14.835-.103.335-.653.143-.653.143zM46.57 57.353c-.112.13-.127.274-.07.428v.002c.104.286.445.605.842.924a4.555 4.555 0 01.165.14l.023.021c.37.341.231.42.895 1.112.758.788 1.28.803 1.428.73.125-.06-.13-.478-.413-.949l-.04-.068-.113-.189c-.331-.565-.246-.83-.167-1.673.064-.683 1.065-3.82 1.065-3.82l-1.452-.251s-.438 2.498-.92 2.883c-.257.204-.546.207-.793.359l-.052.032c-.14.094-.284.19-.397.32v-.001z"
        fill="#FFB27D"
      />
      <Path
        d="M46.57 57.353c-.112.13-.127.274-.07.428v.002c.127.286.46.603.843.921a4.07 4.07 0 01.164.143l.023.021c.37.341.231.42.895 1.112.758.788 1.28.803 1.428.73.125-.06-.13-.478-.413-.949a3.23 3.23 0 01-1.35-.996c-.44-.562-.738-1.276-1.037-1.716l-.085-.016c-.141.093-.285.19-.398.32z"
        fill="#233862"
      />
      <Path
        d="M58.28 56.45c.09.449.73.374 1.443.2.714-.174.544.033 1.56-.078 1.016-.112 1.324-.492 1.355-.642.028-.134-.474-.182-1.012-.243a19.828 19.828 0 01-.204-.025c-.608-.077-1.053-.47-1.606-.791-.522-.306-1.303-1.55-1.303-1.55l-1.393.11s.73 1.111 1.014 1.594c.166.284.157.66.136.95-.01.157-.021.318.01.476z"
        fill="#FFB27D"
      />
      <Path
        d="M59.723 56.65c.714-.174.544.033 1.56-.078 1.016-.112 1.324-.492 1.355-.642.028-.134-.474-.182-1.012-.243l-.005.01s-.61.432-1.455.452c-.69.017-1.419-.182-1.895-.174-.01.157-.021.319.01.477.09.448.73.373 1.442.2v-.002zM52.944 47.54l-1.303 3.504-1.702 4.575s-.461.044-.903-.083c-.407-.117-.874-.426-.874-.426s.474-4.913 1.356-7.733c.225-.724.479-1.31.758-1.64 1.366-1.613 2.668 1.801 2.668 1.801v.002z"
        fill="#233862"
      />
      <Path
        d="M51.622 41.973c-.742-.239-2.676-.005-4.775.374a1.424 1.424 0 01-1.47-.663l-5.28-.415s-1.743 3.864-.79 6.326c.14.363.447.588.923.596 0 0 3.19.006 4.211.006 2.627 0 5.558-1.803 5.938-1.88.62-.123.868 1.119 1.489 2.422.62 1.304 5.833 5.775 5.833 5.775s.801.008 1.133-.116c.355-.134.486-.307.486-.307s-5.774-11.497-7.698-12.118z"
        fill="#2A4E96"
      />
      <Path
        d="M44.823 26.177a1.878 1.878 0 00-1.009-.263 2.807 2.807 0 01-.486-.03c-2.016-.296-3.23 2.631-3.302 3.516-.13 1.623-.99 1.87-2.2 2.887-2.425 2.039-1.715 4.408-.39 5.29.796.528 2.198 0 2.198 0 .02.014 3.836-2.131 5.716-3.166 2.819-.4.605-7.56-.527-8.235v.001z"
        fill="#233862"
      />
      <Path
        d="M43.774 33.53c.008.005-.925.323-1.549.047-.587-.26-1.031-1.226-1.023-1.226.267-.012.56-.246.787-1.778l.114.04 1.912.69s-.139.613-.23 1.198c-.075.49-.115.96-.011 1.03v-.001z"
        fill="#FFB27D"
      />
      <Path
        d="M44.014 31.302s-.076.332-.187.95c-1.098-.198-1.57-1.044-1.724-1.638l1.911.688z"
        fill="#ED975D"
      />
      <Path
        d="M44.3 31.912s-2.617-.353-2.372-1.978c.244-1.626.07-2.767 1.752-2.61 1.68.155 1.911.824 1.962 1.387.05.563-.655 3.25-1.342 3.2z"
        fill="#FFB27D"
      />
      <Path
        d="M45.546 27.82s-1.676 1.442-2.815 1.559c-1.14.116-1.57-.25-1.57-.25s.671-.557 1.076-1.457a.8.8 0 01.66-.472c.814-.07 2.356-.101 2.649.62z"
        fill="#233862"
      />
      <Path
        d="M44.5 27.69s.56.541.736.944c.17.387.22 1.315.085 1.683 0 0 .874-1.697.38-2.522-.524-.875-1.202-.105-1.202-.105z"
        fill="#233862"
      />
      <Path
        d="M45.976 37.385c-.081 5.297-.023 4.19-.603 4.692-.14.121-.532.193-1.049.228-1.624.107-4.479-.161-4.587-.462-.374-1.039-.11-1.361-.422-2.95a12.07 12.07 0 00-.12-.552c-.26-1.092-.513-1.464.412-3.218.839-1.59 1.71-2.878 1.789-2.832 2.211 1.314 2.39.21 2.39.21s2.23 2.301 2.19 4.885z"
        fill="#F99746"
      />
      <Path
        d="M51.64 51.044L49.94 55.62s-.461.044-.903-.083c-.407-.118-.874-.426-.874-.426s.474-4.914 1.356-7.734l2.123 3.667z"
        fill="#2A4E96"
      />
      <Path
        d="M43.786 32.5s2.276.387 2.543 1.367c.267.98 1.145 6.929 1.145 6.929s-.643.627-1.177.092-1.68-5.566-1.68-5.566l-.831-2.82V32.5z"
        fill="#F99746"
      />
      <Path
        d="M44.325 42.304c-1.625.107-4.48-.161-4.588-.462-.374-1.038-.11-1.36-.421-2.95l.784-2.206s-.13 2.457.594 3.102c.723.647 2.965 1.248 3.318 1.789.17.258.281.519.313.727z"
        fill="#ED7D2B"
      />
      <Path
        d="M42.464 41.27s1.603-.355 1.86-.213c.259.142.89.66.97.84.079.18-.575-.137-.788-.194-.138-.037-.501.089-.681.15-.757.251-1.22.121-1.22.121l-.141-.703z"
        fill="#FFB27D"
      />
      <Path
        d="M41.394 32.289s-2.15.131-2.897 1.17c-1.048 1.462-3.13 7.693-1.939 8.525 1.342.936 6.109.247 6.109.247s.159-.742-.062-1.1c-.221-.36-3.807-.94-3.972-1.106-.166-.165 2.07-3.227 2.07-3.724 0-.496.69-4.012.69-4.012h.001z"
        fill="#F99746"
      />
      <Path
        d="M44.403 41.503s.335.433.445.484c.11.052.182.039.182.039l-.226-.407-.401-.117zM44.325 41.057l.976.474s-.041.068-.162.062c-.12-.005-.423-.116-.423-.116l-.391-.42z"
        fill="#FFB27D"
      />
      <Path
        d="M52.66 42.174l-10.196-.004v.225l10.105.004.091-.225z"
        fill="#233862"
      />
      <Path
        d="M44.848 42.396l7.721.003 2.325-5.776-7.71-.002-2.336 5.775z"
        fill="#233862"
      />
      <Path
        d="M50.621 39.51c.059-.203-.059-.368-.262-.368a.527.527 0 00-.473.367c-.059.203.059.368.262.368a.527.527 0 00.473-.367z"
        fill="#fff"
      />
      <Path
        d="M102.875 64.177c-1.04-.346-1.76.09-1.76.09-2.995.123-3.106 3.193-2.755 4.336.494 1.604-1.253 2.87.685 3.518 2.248.754 4.135-.14 4.006.248 7.11.56 2.19-7.407-.176-8.192z"
        fill="#163560"
      />
      <Path
        d="M99.769 79.107s-.285.563-.8 1.21c-.623.78-3.888-1.07-3.607-1.21.282-.14 1.922-4.868 2.313-5.462.391-.594 1.722-.902 1.722-.902l.372 6.364z"
        fill="#F99746"
      />
      <Path
        d="M110.788 110.988s.901.822.725 1.406c-.176.585-.989.975-1.099 1.689-.11.714-.549 1.103-.945 1.103h-1.887s-.291-.502.412-.654c.704-.151.969-.99.925-1.77-.045-.779.066-1.817.066-1.817l1.495-.346.308.389z"
        fill="#1F447F"
      />
      <Path
        d="M103.16 111.337s.324 3.484-.071 3.679l-5.064-.01s0-.585.814-.714c.813-.13 2.242-.607 2.484-1.667.241-1.06 1.837-1.288 1.837-1.288z"
        fill="#1C3154"
      />
      <Path
        d="M107.055 76.757s.075 1.063 0 2.34c-.05.846-.906 1.98-1.028 2.26-.304.704-.648.818-.648.818l-2.659.651-.935.229-2.948-.881s-1.343-3.747-.803-5.857c.539-2.11 1.362-3.575 1.362-3.575s2.004-.45 5.538-.2l2.12 4.214h.001z"
        fill="#F99746"
      />
      <Path
        d="M107.308 79.126c-.05.847-1.159 1.95-1.281 2.231-.304.704-.648.818-.648.818l-2.659.651-.48-1.376s3.885-1.02 3.26-4.616l1.808 2.292z"
        fill="#ED7D2B"
      />
      <Path
        d="M99.025 82.743s-1.46 4.544-1.554 6.091c-.094 1.547 2.791 21.978 2.907 22.69.109.672.944 1.1.944 1.1s.384.227.931.072c.76-.214 1.001-.471 1.001-.471s1.136-14.57.433-19.776c-.704-5.205-.711-9.706-.711-9.706h-3.951z"
        fill="#233862"
      />
      <Path
        d="M105.211 82.608s2.227 2.987 2.434 5.008c.208 2.02.326 9.114.768 11.083.443 1.969 2.068 5.758 2.068 11.9 0 0-.169.351-.69.539a5.81 5.81 0 01-.607.168.955.955 0 01-1.068-.506c-1.099-2.212-4.598-9.346-4.777-10.827-.127-1.048-1.232-7.984-3.643-12.054-.579-.977.355-4.863.355-4.863l5.16-.447v-.001z"
        fill="#2A4E96"
      />
      <Path
        d="M98.792 82.042s.586.463 1.75.486c1.391.029 4.837-.354 4.837-.354s.153.428.147.88c0 0-4.209 1.06-6.647.154 0 0-.315-.592-.087-1.167z"
        fill="#233862"
      />
      <Path
        d="M100.209 83.727c-.35 0-.635-.322-.635-.718 0-.396.285-.718.635-.718.35 0 .635.322.635.718 0 .396-.285.718-.635.718zm0-1.226c-.234 0-.424.228-.424.508s.19.508.424.508c.234 0 .424-.228.424-.508s-.19-.508-.424-.508z"
        fill="#fff"
      />
      <Path
        d="M103.249 85.033l-6.325.06-3.113-7.315 6.325-.06 3.113 7.315z"
        fill="#B5453C"
      />
      <Path
        d="M102.422 81.728l-.464-.57s-.313-.28-.541-.327c-.228-.048-.709-.325-.755-.247-.046.078.369.635.369.635l.021.003c-.477.36-1.683.042-1.831.189-.18.177.248.561.478.777.23.215.888.575 1.401.416.374-.117.964-.236.964-.236l.358-.64zM94.287 79.065s.397-.452.65-.235c.254.216-.066 1.283-.307 1.174-.242-.108-.482-.806-.343-.94z"
        fill="#FFB27D"
      />
      <Path
        d="M104.935 72.543s1.81.2 3.11 2.56c1.025 1.863 2.776 5.295 2.115 6.264-.29.426-3.072 1.94-8.437 1.075 0 0 .084-.677.517-.992 0 0 4.515-1.45 4.508-1.738-.015-.545-.61-1.017-3.133-3.54-.686-.686 1.319-3.63 1.319-3.63h.001z"
        fill="#F99746"
      />
      <Path
        d="M103.541 72.638c.062-.083-.017-.35-.117-.844-.09-.45-.243-1.144-.24-1.924l-.134.022-2.244.378s.052.6.053 1.166v.014c.003.49-.132 1.233.033 1.33.85.497 2.409.18 2.649-.142z"
        fill="#FFB27D"
      />
      <Path
        d="M100.806 70.27s.044.846.047 1.411c1.255-.03 1.926-1.25 2.198-1.789l-2.244.378h-.001z"
        fill="#E8945B"
      />
      <Path
        d="M100.671 71.279s2.942-.42 2.653-2.248c-.289-1.828-.104-3.113-1.995-2.923-1.891.19-2.144.946-2.196 1.58-.052.633.765 3.653 1.538 3.59z"
        fill="#FFB27D"
      />
      <Path
        d="M99.985 66.276s1.146 2.017 2.429 2.138c1.283.12 1.765-.295 1.765-.295s-1.065-.601-1.471-1.881c0 0-2.279-1.079-2.723.038z"
        fill="#163560"
      />
      <Path
        d="M100.212 66.42s-.56.317-.736.79a2.988 2.988 0 00-.13 1.742s-.837-1.361-.288-2.294c.582-.99 1.154-.239 1.154-.239z"
        fill="#163560"
      />
      <Path
        d="M1.946 114.924h163.086c.113 0 .204.092.204.204v.118a.204.204 0 01-.204.204H1.946a.205.205 0 01-.204-.204v-.118c0-.112.091-.204.204-.204z"
        fill="#233862"
      />
    </Svg>
  );
}

export default SvgComponent;
